import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MaPlatePreparationService } from '../ma-plate-preparation/ma-plate-preparation.service';
import { ProcessFlow } from '../masterdata/models/processFlow';
import { MessagesService } from '../messages/messages.service';
import { Plate } from '../models/plate';
import { Sample } from '../models/sample';
import { AnnouncedService } from '../apg-announced/services/announced.service';
import { PlateStatus, ProcessUpdateStage } from '../models/process-step';
import { SampleCommentDTO } from '../models/sampleCommentDTO';
import { SamplePlateHistoryDTO } from '../models/samplePlateHistoryDTO';
import { ProcessUpdateDTO, SampleData } from '../models/wb-process-update';
import {Comment} from "../models/comment";
import prepareRemoveSampleDTO from "../utils/remove-sample-util";

@Component({
	selector: 'app-ma-sample-placement',
	templateUrl: './ma-sample-placement.component.html',
	styleUrls: ['./ma-sample-placement.component.css']
})
export class MaSamplePlacementComponent implements OnInit {

	readonly columnHeaders = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
	readonly rowHeaders = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

	showPlateView: boolean = false;
	samplePlacementPlate: Plate = null;
	samplePlacementPlateID: string = "";
	disableSamplePlacementPlateIDField: boolean = false;
	selectedCell: string = "A1";
	plateSamplesMap: Map<string, Sample> = new Map();
	scannedBarcode: string = "";
	positionBarcodeMap: Map<string, string> = new Map();
	selectedLabId: string;
	sampleBarcodeMap: Map<string, string> = new Map();
	samplePlacementPlateSampleType: string = "";
	sampleTypeList = [];
	blocked: boolean = false;
	isSampleSelectionOn: boolean = false;
	selectedPositions: Map<string, Sample> = new Map();
	allSelectedSamples: any[] = [];
	duplicateSamplesPopUpNormalPlate: boolean = false;
	duplicateSamplesPresent: boolean = false;
	sampleData: Sample = new Sample();
	selectedPickedSample: Sample = new Sample();
	sampleCheckErrorMessage: string = '';
	showSampleCheckFailedDialog: boolean = false;
	existingPositions: string[] = [];
	puid: string;
	addedSamplesInExtractedPlate = new Set();

	@Input() processFlowNameProcessFlowMap: Map<string, ProcessFlow> = new Map();
	@Input() selectedProcessFlows: ProcessFlow[];
	@Input() isProcessUpdateProxied: boolean = false;
	@Output() onClose = new EventEmitter<any>();

	constructor(private _messagesService: MessagesService, private platePreparationService: MaPlatePreparationService, private announcementService: AnnouncedService) { }

	ngOnInit() {
		this.showPlateView = false;
		this.samplePlacementPlateID = "";
		this.scannedBarcode = "";
		this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
		this.puid = localStorage.getItem('PUID');
	}

	resetField() {
		this.samplePlacementPlateID = "";
		this.disableSamplePlacementPlateIDField = false;
		this.showPlateView = false;
		this.scannedBarcode = "";
		this.selectedCell = "A1";
		this.isSampleSelectionOn = false;
		this.selectedPositions.clear();
		this.performProcessUpdateForWeatherby(new Array(...this.addedSamplesInExtractedPlate.values()));
		setTimeout(() => {
			this.findAndHighlightElement('sample-placement-input')
		}, 200)
	}

	preparePositionBarcodeMap(plate: Plate){
		plate.samples.forEach(samp => {
			this.positionBarcodeMap.set(samp.position, samp.sampleID)
		})
	}

	extractPlateSampleType(plate: Plate){
		let plateSampleTypes = plate.sampleType.split(",").map(item => item.trim())
		return plateSampleTypes[plateSampleTypes.length - 1]
	}

	checkPlateForSamplePlacement() {
		this.scannedBarcode = "";

		this.positionBarcodeMap = new Map();
		this.blocked = true;
		this.platePreparationService.fetchPlate(this.samplePlacementPlateID, this.selectedLabId).subscribe({
			next: (result) => {
				this.blocked = false;
				if (!this.validateFetchedPlate(result)) {
					return;
				}

				this.samplePlacementPlate = result;
				this.preparePositionBarcodeMap(this.samplePlacementPlate);
				this.getSelectedCellPosition();
				this.prepareSamplesMap();
				this.samplePlacementPlateSampleType = this.extractPlateSampleType(this.samplePlacementPlate);
				this.disableSamplePlacementPlateIDField = true;
				this.showPlateView = true;

				setTimeout(() => {
					this.findAndHighlightElement('barcode-scanner');
				}, 500)

			},error:  (_error) => {
				this.blocked = false;
				this._messagesService.addErrorMessage({
					severity: "error", "summary": "Plate not found!",
					detail: "Plate not found with plate id - " + this.samplePlacementPlateID
				})
				this.samplePlacementPlateID = "";
			}
		})
	}

	closeSampleCheckFailedDialog(){
		this.showSampleCheckFailedDialog = false;
		this.findAndHighlightElement('barcode-scanner');
	  }

	getSampleAt(row: number, col: number) {
		let positionString = this.getRowColStringFromPos(row, col);
		if (this.plateSamplesMap.has(positionString)) {
			return this.plateSamplesMap.get(positionString);
		}
		let sample = new Sample();
		sample.sampleID = '';
		return sample;
	}

	getRowColStringFromPos(row: number, col: number) {
		return this.rowHeaders[row] + this.columnHeaders[col];
	}

	checkSelectedCell(row: number, col: number) {
		return this.getRowColStringFromPos(row, col) == this.selectedCell
	}

	determineClassForDifferentSampleBarcodes(i, j) {
		let sampleAtPosition = this.getSampleAt(i, j);
		let isSelectedCell = this.checkSelectedCell(i, j);
		if(this.isSampleSelectionOn && this.selectedPositions.has(this.getRowColStringFromPos(i, j))){
			return "selected-removal-cells";
		}
		else if (isSelectedCell) {
			return "selected-cell";
		}
		else if (!isSelectedCell && sampleAtPosition.sampleID != '' && !sampleAtPosition.reProcessed) {
			return "cell-with-value";
		}
		else if (!isSelectedCell && sampleAtPosition.sampleID != '' && sampleAtPosition.reProcessed) {
			return "cell-with-value-processed";
		}
		else if (!isSelectedCell && sampleAtPosition.sampleID == '') {
			return "";
		}
		else {
			return "";
		}
	}

	findAndHighlightElement(elementId) {
		let element = document.getElementById(elementId);
		if (element) {
			element.focus();
		}
	}

	checkAndPlaceSample() {
		this.scannedBarcode = this.scannedBarcode.trim();

		if ("" == this.scannedBarcode.trim()) {
			return;
		}

		if (!this.showPlateView) {
			this._messagesService.addWarningMessage({
				severity: "warn", summary: "Sample not placed!",
				detail: `"PlateID ${this.samplePlacementPlateID} is not valid`
			})
			return;
		}

		let requestBody = {};
		requestBody["labId"] = this.selectedLabId;
		requestBody["plateId"] = this.samplePlacementPlateID;
		requestBody["selectedSampleType"] = this.samplePlacementPlateSampleType;
		requestBody["sampleBottomBarcode"] = this.scannedBarcode;
		requestBody["position"] = this.selectedCell;
		this.blocked = true;
		this.announcementService.placeRemovedSRCSample(requestBody).subscribe({
			next: (result) => {
				this.blocked = false;
				let sample = this.createNewSample(this.selectedCell, result.data);
				sample["currentPlatePriority"] = this.samplePlacementPlate.priority;
				let plateDueDate = this.samplePlacementPlate.dueDate;
				if (this.samplePlacementPlate.dueDate < sample.dueDate) {
					sample.plateDueDate = plateDueDate;
				} else {
					sample.plateDueDate = sample.dueDate;
				}
				this.blocked = true;
				this.platePreparationService.addSampleToPlate(this.selectedLabId, this.samplePlacementPlateID, sample).subscribe({
					next: result => {
						this.blocked = false;
						this.samplePlacementPlate = result;
						this.preparePositionBarcodeMap(this.samplePlacementPlate);
						this.prepareSamplesMap();
						this._messagesService.addSuccessMessage({
							severity: "success", summary: "Sample placed!"
						})
						if (sample.icbfSampleID != 0) {
							this.addedSamplesInExtractedPlate.add(sample._id);
						}
						this.scannedBarcode = "";
					},error:  _error => {
						this.blocked = false;
						this._messagesService.addSuccessMessage({
							severity: "error", summary: "Sample not placed!",
							detail: "Error occured while adding sample to the plate!"
						})
					}
				});
			},
			error: (error: any) => {
				this.blocked = true;
				this.placeRemovedNonSRCSample();
			}
		})
	}

	placeRemovedNonSRCSample(){
	this.blocked = true;
    this.announcementService.getSampleFromDelivery(this.selectedLabId,this.scannedBarcode).subscribe({
		next: (result) => {
        this.blocked = false
        this.allSelectedSamples = result.data
        if(this.allSelectedSamples.length>1){
          this.duplicateSamplesPopUpNormalPlate = true
          this.setDuplicateSamplesPopUp()
        }
        else if(this.allSelectedSamples.length == 1){
          this.sampleData = result.data
          this.sampleData = this.sampleData[0]
          if(this.sampleData.receptionStatus === "REMOVED"){
            this._messagesService.addWarningMessage({
              severity:"warn",summary:"Unsuitable sample scanned",
              detail:`Sample ${this.scannedBarcode} is marked as unsuitable.`
            })
            return;
          }
		  if(!this.sampleData.boxReceptionTimeStamp){
			this._messagesService.addWarningMessage({
				severity:"warn",summary:"Invalid Sample",
				detail:`Sample ${this.scannedBarcode} is not allowed in this plate.`
			  })
			  return;
		  }
		  if(this.sampleData.storage){
			this._messagesService.addWarningMessage({
				severity:"warn",summary:"Storage Sample not Allowed",
				detail:`Sample ${this.sampleData.barCode} is in storage and not allowed to be placed on the plate.`
				})
				return;
		}
          this.checkIfCellIsEmptyAndAddSample(false, "redo");
        }
      },
      error: (error: any) => {
        this.blocked = false;
        this.sampleCheckErrorMessage = "Sample " + this.scannedBarcode + " was not announced in the manifest for project."
        this.showSampleCheckFailedDialog = true;
      }
	})
	}

	checkIfCellIsEmptyAndAddSample(storagePlate: boolean, sampleType: string=""){
		if(!this.existingPositions.includes(this.selectedCell)){
		  if(!storagePlate){
			if(sampleType === ""){
				return;
			}
			else{
			  this.normalBarcodePlate(sampleType);
			}
		  }
		}
		else{
		  this._messagesService.addErrorMessage({
			severity:"error", summary:"Cell is already occupied ",
			detail: "Sample already present"
		  })
		  if(!storagePlate && sampleType!=""){
			this.setDuplicateSamplesPopUp();
		  }
		}
	  }

	addSampleToPlateForDeliveryService(sample_id: string, sample_barcode: string, addComment: boolean, addPlateHistory: boolean, addReceptionValues:boolean){
		let data = {}
		data['addComment'] = addComment;
		data['addPlateHistory'] = addPlateHistory;
		if(!('receptionDateTime' in this.sampleData) || this.sampleData.receptionDateTime == null){
		  data['addReceptionValues'] = addReceptionValues;
		}
		else{
		  data['addReceptionValues'] = false
		}

		let plateSampleTypes = this.samplePlacementPlate.sampleType.split(",");
		let latestPlateSampleType = plateSampleTypes[plateSampleTypes.length-1];
		if(latestPlateSampleType!= this.sampleData.sampleType){
		  data['addComment'] = true;
		  this.sampleCheckErrorMessage =  "Sample was received as "+ this.samplePlacementPlateSampleType;
		}
		data['selectedSampleType'] = latestPlateSampleType;
		let comment = new SampleCommentDTO();
		comment.comment = this.sampleCheckErrorMessage;
		comment.puid = this.puid;
		comment.status = "SAMPLE_RECEPTION";
		data['comment'] = comment;

		let plateHistory = new SamplePlateHistoryDTO();
		plateHistory.plateId = this.samplePlacementPlateID
		plateHistory.position = this.selectedCell;
		plateHistory.approved = true;

		data['plateHistory']=plateHistory;
		data['puid'] = this.puid;
		data['boxID'] = !this.sampleData.boxID ? this.samplePlacementPlate.delivery : this.sampleData.boxID;

		data['status'] = "UNBOXED";
		data['storage'] = this.samplePlacementPlate.storagePlate;
		data['sampleType'] = this.sampleData.sampleType
		data['projectID']=this.sampleData.projectID;

		this.blocked = true;
		this.announcementService.addSampleToPlate(this.selectedLabId, sample_id, data).subscribe({
			next: result => {
			this.blocked = false;
			if(result.data != null){
			  plateHistory.sampleId = sample_barcode;
			  plateHistory._id = sample_id
			  this.addedSamplesInExtractedPlate.delete(sample_id);
			}
		  },
		  error: error => {
			this.blocked = false;
			this._messagesService.addErrorMessage({
			  severity: 'error', summary:"Sample Update Failed",
			  detail: "Sample update for plate history and comment failed!\n"+error
			})
			this.scannedBarcode = '';
		  }
		})
	  }

	normalBarcodePlate(text: string){
		this.blocked = true;
		this.platePreparationService.checkSamplePresentInPlate(this.selectedLabId, this.sampleData._id).subscribe({
			next: (result_value) => {
				this.blocked = false;
				if (result_value.present) {
					this._messagesService.addWarningMessage({
						severity: 'warn', summary: 'Invalid Barcode',
						detail: "Barcode: '" + this.scannedBarcode + "' is already scanned in Plate " + result_value.plateID + ". Please scan a different barcode.",
					});
					this.sampleCheckErrorMessage = "Barcode: '" + this.scannedBarcode + "' is already scanned. Please scan a different barcode."
					return;
				}
				if (!this.sampleData.activated) {
					this.sampleCheckErrorMessage = "Sample " + this.scannedBarcode + " is not yet activated!"
					this.showSampleCheckFailedDialog = true;
				}
				else {
					let newSample = this.createNewSample(this.selectedCell, this.sampleData);
					newSample.isRedoSample = result_value.redo;
					let plateDueDate = this.samplePlacementPlate.dueDate;
					if (this.samplePlacementPlate.dueDate < newSample.dueDate) {
						newSample.plateDueDate = plateDueDate;
					} else {
						newSample.plateDueDate = newSample.dueDate;
					}
					this.addSampleToPlateForDeliveryService(this.sampleData._id, this.scannedBarcode, false, true, false);
					this.blocked = true;
					this.platePreparationService.addSampleToPlate(this.selectedLabId, this.samplePlacementPlate.plateID, newSample).subscribe({
						next: result => {
							if(this.sampleData.icbfSampleID) this.addedSamplesInExtractedPlate.add(this.sampleData._id);
							this.platePreparationService.updateReProcessedToSample(this.selectedLabId, this.sampleData._id).subscribe({
								next: (_result) => {
									this.blocked = false;
								},
								error: error => {
									this.blocked = false;
									this._messagesService.addErrorMessage({
										severity: "error", summary: " Error occured in re processing a sample " + this.scannedBarcode,
										detail: error.error
									})
								}
							})
							if (text == 'duplicate') {
								this.duplicateSamplesPopUpNormalPlate = false;
								this.setDuplicateSamplesPopUp()
							}
							this.scannedBarcode = '';
							this.samplePlacementPlate = result;
							this.sampleBarcodeMap.set(this.selectedCell, this.scannedBarcode);
							this.plateSamplesMap.set(this.selectedCell, newSample);
							if (this.samplePlacementPlate.samples.length == 96) {
								this.selectedCell = "A1"
							}
							else {
								this.incrementSelectedCell();
							}
							this._messagesService.addSuccessMessage({
								severity: 'success', summary: "Sample Added!",
								detail: "Sample " + this.scannedBarcode + " added to plate " + this.samplePlacementPlate.plateID
							});
							this.scannedBarcode = '';
						},
						error: error => {
							this.blocked = false;
							this._messagesService.addErrorMessage({
								severity: 'error', summary: "Sample Not Added!",
								detail: error
							})
							this.scannedBarcode = '';
						}
					});
					this.findAndHighlightElement('barcode-scanner');
				}
			},
			error: error => {
				this.blocked = false;
				this._messagesService.addErrorMessage({
					severity: "error", summary: " Sample " + this.scannedBarcode + " not Present in Storage Plate.",
					detail: error
				})
			}
		})

	}

	setDuplicateSamplesPopUp(){
		this.duplicateSamplesPresent = this.duplicateSamplesPopUpNormalPlate;
	}


	resetValues(event){
		this.duplicateSamplesPopUpNormalPlate = false;
		this.duplicateSamplesPresent = false;
		this.blocked = false;
		this.setDuplicateSamplesPopUp()
	}

	selectedSampleFromScan(sample){
		this.announcementService.putBarcodeInSample(this.scannedBarcode, sample).subscribe({
		  next: (result) => {
			this.blocked = false;
			this.selectedPickedSample = result.data
			if(this.duplicateSamplesPopUpNormalPlate){
			  this.saveBarcodeForNormalPlateAfterDuplicateSelection(this.selectedPickedSample)
			}
		  },
		 error: (error: any) => {
			this.blocked = false;
			this._messagesService.addErrorMessage({
			  severity:"error", summary:"Encountered error fetching Sample "+this.scannedBarcode,
			  detail: error
			});
		  }
		});
	  }

	getSelectedCellPosition() {
		if (this.samplePlacementPlate.scanHorizontal) {
			for (let i = 0; i < this.rowHeaders.length; i++) {
				for (let j = 0; j < this.columnHeaders.length; j++) {
					if (!this.positionBarcodeMap.has(this.rowHeaders[i] + this.columnHeaders[j])) {
						this.selectedCell = this.rowHeaders[i] + this.columnHeaders[j]
						return;
					}
				}
			}
		}
		else {
			for (let i = 0; i < this.columnHeaders.length; i++) {
				for (let j = 0; j < this.rowHeaders.length; j++) {
					if (!this.positionBarcodeMap.has(this.rowHeaders[j] + this.columnHeaders[i])) {
						this.selectedCell = this.rowHeaders[j] + this.columnHeaders[i]
						return;
					}
				}
			}
		}
	}

	saveBarcodeForNormalPlateAfterDuplicateSelection(sample){
		this.sampleData = sample
		let flagSampleExists = false
		this.samplePlacementPlate.samples.forEach(res => {
		  if(res._id == sample._id){
			this._messagesService.addErrorMessage({
			  severity: 'error', summary:"Sample Not Added!",
			  detail: "Sample already exists"
			})
			flagSampleExists = true
		  }
		})
		if(flagSampleExists){
		  this.setDuplicateSamplesPopUp()
		  return
		}
		if(sample.receptionStatus === "REMOVED"){
		  this._messagesService.addWarningMessage({
			severity:"warn",summary:"Unsuitable sample scanned",
			detail:`Sample ${this.scannedBarcode} is marked as unsuitable.`
		  })
		  return;
		}
		this.blocked = true;
		this.platePreparationService.checkSamplePresentInPlate(this.selectedLabId, this.sampleData._id).subscribe({
			next: (result_value)=>{
			this.blocked = false;
			if(result_value.present){
			  this._messagesService.addWarningMessage({
				severity: 'warn', summary: 'Invalid Barcode',
				detail: "Barcode: '"+this.scannedBarcode +"' is already scanned in Plate "+ result_value.plateID +". Please scan a different barcode.",
			  });
			  this.sampleCheckErrorMessage = "Barcode: '"+this.scannedBarcode +"' is already scanned. Please scan a different barcode."
			  return;
			}
			if(!sample.activated){
			  this.sampleCheckErrorMessage = "Sample " + this.scannedBarcode + " is not yet activated!"
			  this.showSampleCheckFailedDialog = true;
			  return
			}
			if(this.sampleData.storage){
				this._messagesService.addWarningMessage({
					severity:"warn",summary:"Storage Sample not Allowed",
					detail:`Sample ${sample.barCode} is in storage and not allowed to be placed on the plate.`
					})
					return;
			}
			this.checkIfCellIsEmptyAndAddSample(false, "duplicate");
		  },
		  error: error => {
			this.blocked = false;
			this._messagesService.addErrorMessage({
			  severity:"error", summary:" Sample "+this.scannedBarcode+" not Present in Storage Plate.",
			  detail: error
			})
		  }
		})
	  }

	prepareSamplesMap(changeSelectedCell: boolean = true) {
		this.sampleBarcodeMap.clear();
		this.plateSamplesMap.clear();
		this.samplePlacementPlate.samples.forEach(sample => {
			this.sampleBarcodeMap.set(sample.position, sample.sampleID);
			this.plateSamplesMap.set(sample.position, sample);
		})
		if (this.samplePlacementPlate.samples.length != 0 && this.scannedBarcode != "" && changeSelectedCell)
			this.incrementSelectedCell();
	}

	incrementSelectedCell() {
		if (this.sampleBarcodeMap.size == 96) {
			this._messagesService.addSuccessMessage({
				severity: 'success', summary: 'All Plates Scanned',
				detail: 'All plates are scanned. Please click to complete QC Scan.'
			});
			return;
		}
		let row = this.selectedCell[0], col = Number.parseInt(this.selectedCell.substring(1)), rowDiff = 0;

		if (this.samplePlacementPlate.scanHorizontal) {
			let rowIndex
			while (true) {
				rowIndex = col == this.columnHeaders[11] ? this.rowHeaders.indexOf(row) + 1 : this.rowHeaders.indexOf(row)
				row = rowIndex == 8 ? this.rowHeaders[0] : this.rowHeaders[rowIndex]
				col = col == 12 ? 1 : col + 1
				if (!this.sampleBarcodeMap.has(row + col)) {
					this.selectedCell = row + col;
					break;
				}
			}
		}
		else {
			while (true) {
				col = row == this.rowHeaders[7] ? col + 1 : col;
				col = col == 13 ? 1 : col;
				rowDiff = row.charCodeAt(0) - 'A'.charCodeAt(0)
				row = this.rowHeaders[rowDiff == 7 ? 0 : rowDiff + 1];
				if (!this.sampleBarcodeMap.has(row + col)) {
					this.selectedCell = row + col;
					break;
				}
			}
		}
	}

	validateFetchedPlate(fetchedPlate: Plate) {
		let isPlateValid: boolean = true;

		if (fetchedPlate.status != PlateStatus.EXTRACTION_COMPLETED) {
			this._messagesService.addErrorMessage({
				severity: "error", summary: "Plate Not Eligible",
				detail: `Plate is not in correct status! Current Status - ${fetchedPlate.status}, Required Status -${PlateStatus.EXTRACTION_COMPLETED}`
			})
			isPlateValid = false;
		}

		else if (fetchedPlate.samples.length == 96) {
			this._messagesService.addErrorMessage({
				severity: "error", summary: "Plate Not Eligible",
				detail: "Plate has all 96 positions filled!"
			})
			isPlateValid = false;
		}

		if (!isPlateValid) {
			fetchedPlate = null;
			this.samplePlacementPlateID = "";
		}

		return isPlateValid
	}

	createNewSample(position: string, sampleData: Sample) {
		const newSample = new Sample();
		newSample._id = sampleData._id;
		newSample.position = position;
		newSample.sampleID = sampleData.barCode;
		newSample.beadChipID = '';
		newSample.beadChipPosition = '';
		newSample.plateRedo = false;
		newSample.priority = sampleData.priority;
		newSample.redoBeadChipID = '';
		newSample.redoBeadChipPosition = '';
		newSample.sampleType = sampleData.sampleType;
		newSample.singleRedo = false;
		newSample.toBePicked = false;
		newSample.icbfSampleID = sampleData.icbfSampleID ? sampleData.icbfSampleID : 0;
		newSample.reRunCount = sampleData.reRunCount;
		newSample.autoRerun = sampleData.autoRerun;
		newSample.qcSampleHistory = [];
		newSample.assignedSampleType = this.samplePlacementPlateSampleType;
		newSample.boxID = sampleData.boxID;
		newSample.boxReceptionTimeStamp = this.convertToDate(sampleData.boxReceptionTimeStamp);;
		newSample.projectID = sampleData.projectID;
		newSample.dueDate = sampleData.dueDate;
        newSample.receptionPUID = this.puid;
		newSample.mintSampleID = sampleData.mintSampleID
        newSample.parentMintSampleID = sampleData.parentMintSampleID;
        newSample.parentSampleID = sampleData.barCode;

		let gender = sampleData.gender;
		if (gender == "M") {
			newSample.gender = "male";
		} else if (gender == "F") {
			newSample.gender = "female";
		}
		else {
			newSample.gender = gender;
		}

		return newSample;
	}

	convertToDate(date: Date): Date {
		if (!date || date == null) {
			return;
		}
		return new Date(date);
	}

	closePopUp() {
		this.resetField();
		this.onClose.emit();
	}

	turnOnSampleSelection() {
		this.isSampleSelectionOn = true;
		this.selectedCell = "";
		this.selectedPositions.clear();
	}

	turnOffSampleSelection() {
		this.isSampleSelectionOn = false;
		this.selectedPositions.clear();
		this.getSelectedCellPosition();
	}

	selectSample(row: number, col: number) {
		let positionString = this.getRowColStringFromPos(row, col);

		if (this.selectedPositions.has(positionString)) {
			this.selectedPositions.delete(positionString)
			return;
		}

		if (!this.plateSamplesMap.has(positionString)) {
			return;
		}

		this.selectedPositions.set(positionString, this.plateSamplesMap.get(positionString));
	}

	removeSamples() {
        const samplePositionList = Array.from(this.selectedPositions.keys());
		const body = prepareRemoveSampleDTO(
			this.samplePlacementPlate,
			this.selectedLabId,
			samplePositionList,
			this.puid,
			this.sampleBarcodeMap
		)
        this.blocked = true;
		this.platePreparationService.removeSamples(body).subscribe({
			next: _res_samples => {
				this.blocked = false;
				let sampleIDList = [];
				this.selectedPositions.forEach((value, _key) => {
					sampleIDList.push(value._id);
					this.addedSamplesInExtractedPlate.delete(value._id);
				})
				body["sampleList"] = sampleIDList;
				this.blocked = true;
				this.announcementService.removeSamples(body).subscribe({
					next: _res_delivery => {
						this.blocked = false;
						this.isSampleSelectionOn = false;
						this.selectedPositions.clear();
						this._messagesService.addSuccessMessage({
							severity: 'success', summary: 'Sample(s) removed from plate!',
						})
						this.checkPlateForSamplePlacement();

					},
					error: error => {
						this.blocked = false;
						this._messagesService.addErrorMessage({
							severity: "error", summary: "Error occured!",
							detail: error.bbApiError.message
						})
					}
				})
			},
			error: (_error) => {
				this.blocked = false;
				this._messagesService.addErrorMessage({
					severity: 'error', summary: 'Error',
					detail: "Samples were not removed!"
				})
			}
		})
	}

	disableRemoveSamplesButton(){
		return (this.selectedPositions.size == 0)
	}

	performProcessUpdateForWeatherby(samples: Array<any>) {
		let weatherbySampleDataList = samples.map<SampleData>(sample => { return {
			sampleId:sample,
			description: "",
			stageGate : 3,
			status: ProcessUpdateStage.STAGE_GATE
		}})

		if(weatherbySampleDataList.length == 0){
			return;
		}

		let weatherByProcessUpdateDto: ProcessUpdateDTO = {
			data: weatherbySampleDataList,
			labId: this.selectedLabId
		}
		this.announcementService.weatherbyProcessUpdate(weatherByProcessUpdateDto, this.isProcessUpdateProxied).subscribe({
			next: (_result) => {
				this.addedSamplesInExtractedPlate.clear();
			},
			error: (error) => {
				this._messagesService.addErrorMessage({
					severity: 'error', summary: 'Something went wrong',
					detail: `Error occurred while sending process update to weatherbys.Error: ${error.bbApiError.message} `
				})
				this.addedSamplesInExtractedPlate.clear();
			}
		})
	}

    checkIfSampleIsDisabledForSelection(sample: Sample): boolean {
        return sample.receptionStatus === "REMOVED" || sample.sampleCompletionDate !== null;
    }
}
